export function determineNumberValue(value: string) {
  if (!value) return null;

  const parsedValue = parseInt(value);

  if (isNaN(parsedValue)) return null;

  return parsedValue;
}
